import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Field, reduxForm } from 'redux-form';
import { combineValidators, isRequired } from 'revalidate';
import {
  Button,
  Form,
  FormGroup,
  Modal,
  ModalBody,
  ModalHeader
} from 'shards-react';
import { sendForgotPasswordEmail } from '../../../../pages/Auth/authActions';
import TextInput from '../../../form/TextInput';
import { closeModal } from '../../modalActions';

const actions = {
  closeModal,
  sendForgotPasswordEmail
};

const validate = combineValidators({
  displayName: isRequired('display name'),
  email: isRequired('email'),
  password: isRequired('password')
});

class ForgotPasswordModal extends Component {
  render() {
    const { closeModal, sendForgotPasswordEmail, handleSubmit } = this.props;
    return (
      <Modal
        open={true}
        toggle={closeModal}
        backdrop={true}
        backdropClassName='backdrop'
        modalClassName='modal'
        fade={true}
        role='dialog'
      >
        <ModalHeader className='bg-primary1'>Password Reset</ModalHeader>
        <ModalBody>
          <Form>
            <p>
              Please enter the email address that you used to register an
              account with NCCC
            </p>
            <FormGroup className='text-left'>
              <label htmlFor='email'>Email</label>
              <Field
                name='email'
                type='email'
                placeholder='Enter Email'
                component={TextInput}
              />
            </FormGroup>
            <div className='home-buttons d-flex w-100 justify-content-between px-3'>
              <Button theme='danger' name='dismiss' onClick={closeModal}>
                Dismiss
              </Button>
              <Button
                theme='success'
                type='submit'
                onClick={handleSubmit(sendForgotPasswordEmail)}
              >
                Send Email
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
    );
  }
}

export default compose(
  connect(null, actions),
  reduxForm({ form: 'forgotForm', validate })
)(ForgotPasswordModal);
